import http from 'hub-http/clients/apiClient';
export function updateCampaignAssociations(workflowId, campaignIds) {
  return http.put(`automation/v3/workflows/${workflowId}/campaigns`, {
    data: campaignIds
  });
}